import { Directive, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';
import { KEY_CODES } from '../lib/key-codes';

@Directive({
  selector: '[naturalNumbersOnlyInput]',
})
export class NaturalNumbersOnlyInputDirective {
  @Output() private ngModelChange: EventEmitter<any> = new EventEmitter();
  private inputElement: HTMLInputElement;

  constructor(el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  private get isInputTypeNumber(): boolean {
    return this.inputElement.getAttribute('type') === 'number';
  }

  @HostListener('keydown', ['$event'])
  private onKeyDown(e: KeyboardEvent): void {
    if (!this.isInputTypeNumber) return;
    if (
      [KEY_CODES.Delete, KEY_CODES.Backspace, KEY_CODES.Tab, KEY_CODES.Esc, KEY_CODES.Enter].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === KEY_CODES.A && e.ctrlKey === true) ||
      (e.keyCode === KEY_CODES.C && e.ctrlKey === true) ||
      (e.keyCode === KEY_CODES.V && e.ctrlKey === true) ||
      (e.keyCode === KEY_CODES.X && e.ctrlKey === true) ||
      (e.keyCode === KEY_CODES.R && e.ctrlKey === true) ||
      (e.keyCode === KEY_CODES.A && e.metaKey === true) ||
      (e.keyCode === KEY_CODES.C && e.metaKey === true) ||
      (e.keyCode === KEY_CODES.V && e.metaKey === true) ||
      (e.keyCode === KEY_CODES.X && e.metaKey === true) ||
      (e.keyCode === KEY_CODES.R && e.metaKey === true) ||
      (e.keyCode >= KEY_CODES.End && e.keyCode <= KEY_CODES.RightArrow) // Left, Right, Home, End
    ) {
      return;
    }
    if (
      (e.shiftKey || (e.keyCode < KEY_CODES[0] || e.keyCode > KEY_CODES[9])) &&
      (e.keyCode < KEY_CODES.Numpad0 || e.keyCode > KEY_CODES.Numpad9)
    ) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  private onPaste(event): void {
    if (!this.isInputTypeNumber) return;
    event.preventDefault();
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedInput: string = clipboardData.getData('text').replace(/\D/g, '');
    this.inputElement.value = pastedInput;
    this.ngModelChange.emit(this.inputElement.value);
  }

  @HostListener('drop', ['$event'])
  private onDrop(event): void {
    if (!this.isInputTypeNumber) return;
    event.preventDefault();
    const textData = event.dataTransfer.getData('text').replace(/\D/g, '');
    this.inputElement.focus();
    this.inputElement.value = textData;
    this.ngModelChange.emit(this.inputElement.value);
  }
}
